import { useState, useEffect, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export default function usePagination(
  data = [],
  itemsPerPage = 10,
  loading,
  updateUrl = true
) {
  /**
   * Function used determine the initial selected page based on the
   * initialPage prop
   */

  const history = useHistory()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const initialPage = parseInt(params.get('page') ?? 1, 10)

  const [page, setPage] = useState(initialPage - 1)
  const pageSize = itemsPerPage
  const pageCount = Math.ceil(data.length / pageSize)
  /**
   * Function used to set the current selected page based on the pagecount
   *
   * @param {integer} selectedItem
   */
  const changePage = useCallback(
    selectedItem => {
      const newPage =
        selectedItem < 0
          ? 0
          : selectedItem > pageCount
          ? pageCount
          : selectedItem

      if (updateUrl) {
        history.replace({
          pathname: location.pathname,
          search: `?page=${newPage + 1}`,
          state: location.state
        })
      }

      setPage(newPage)
    },
    [history, location, pageCount, updateUrl, setPage]
  )

  /**
   * Function used to handle click on the pagination number links
   *
   * @param {integer} selected
   * @param {object} evt
   */
  const handlePageSelected = (selected, evt) => {
    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false)
    if (page === selected) return
    changePage(selected)
  }

  // This reset the selected page to 0 if the data set changes
  useEffect(() => {
    if (data.length < page * pageSize && !loading) {
      setPage(pageCount - 1)
    }
  }, [data.length, page, pageCount, pageSize, loading])

  return {
    pagination: {
      items: data,
      handlePageSelected,
      subset: data.slice(page * pageSize, page * pageSize + pageSize),
      pageCount,
      selectedPage: page,
      onFirstPage: page <= 0,
      onLastPage: pageCount === 1 || page >= pageCount - 1,
      pageSize,
      changePage
    }
  }
}
